import { useRef, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import useConfiguration from "../../../../hooks/useConfiguration";
import useSessionStorage from "../../../../hooks/useSessionStorage";
import { setLoading } from "../../../common/Loader/slice";
import ModalWithPagination from "../../../common/Modal/modalWithPagination";
import {
  clearData,
  getCandidateLocationStatus,
  getCandidateRating,
  getCandidateSearchViewDetail,
  getCertificationsList,
  getEmployersVerificationCommentsHistory,
  loadMasterData,
  saveCertificationEmployerValidation,
  sendMailToCandidateNoUploadCertificate,
  updateCertificationsData,
} from "./action";
import { candidateSearchViewSelector } from "./selector";
import { setError, setLoadingFlagDecrement, setLoadingFlagIncrement } from "./slice";
import Modal from "../../../common/Modal/modal";
import { toast } from "react-toastify";
import { localHostBaseURL } from "../../../../helpers/domainURL";

export default (props) => {
  // get form detials for canddiate search view selector
  const { EmployerValidationGetCertificationList, newCertificationsDuplicate } = useSelector(
    candidateSearchViewSelector
  );
 
  // Employer History Modal Show and Not Show
  const [
    employersVerificationHistoryModalShow,
    setEmployersVerificationHistoryModalShow,
  ] = useState(false);
  // Hooks
  const dispatch = useDispatch();
  const config = useConfiguration();
  const baseUrl = config.baseUrl;
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const location = useLocation();
  const { userData } = location.state || {};
  const [certificationValidationId, setCertificationValidationId] = useState()

  // Send Mail for certifications Part (While click "No" in Upload section open a Popup)
  const [mailPopup, setMailPopup] = useState(false);

  // Send Mail for certifications No upload get a Input Message
  const [mailPopupText, setMailPopupText] = useState();

  // Send Mail for mail popup input Error Validation
  const [errorMailPopupText, setErrorMailPopupText] = useState();

  // Send Mail popup open function
  const sendMailModalOpen = (validationId) => {
    setMailPopup(true);
    if (validationId) {
      setCertificationValidationId(validationId);
    }
  }

  // Send Mail popup open function
  const sendMailModalClose = () => {
    setMailPopup(!mailPopup);
    setErrorMailPopupText("")
    setMailPopupText("");

    const updateVal = JSON.parse(
      JSON.stringify(EmployerValidationGetCertificationList)
    );
    
    const newUpdateVal = JSON.parse(
      JSON.stringify(newCertificationsDuplicate)
    );

    newUpdateVal?.forEach((item) => {
      if (item.candidateCertificationId === certificationValidationId) {
        const correspondingItem = updateVal?.find(
          (updateItem) => updateItem.candidateCertificationId === certificationValidationId
        );
        if (correspondingItem) {
          correspondingItem.validationState = item.validationState;
        }
      }
    });

    dispatch(updateCertificationsData(updateVal));
  }

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10) + "T00:00:00";


  // Send Mail popup API Method
  const sendMailToCandidateNoUploadcertificate = () => {
    if (mailPopupText?.length > 0) {
      dispatch(
        sendMailToCandidateNoUploadCertificate(
          `${config.baseUrl}`,
          userData.candidateUniqueId,
          mailPopupText,
          window.location.hostname
        )
      )
     

      if (userData && userData.candidateUniqueId) {
        const candidateRatingJson = {
          candidateUniqueId: userData.candidateUniqueId,
          jobUniqueId: "",
          locationId: 0,
          employerUniqueId: login.employerUniqueId,
        };

        dispatch(
          loadMasterData(`${config.baseUrl}`, login.employerUniqueId)
        ).then(() => {
          dispatch(
            getCandidateSearchViewDetail({
              url: `${config.baseUrl}/Candidates/get-candidate-infoV2`,
              candidateUniqueId: userData.candidateUniqueId,
              employerUniqueId: login.employerUniqueId,
            })
          ).then(() => {
            dispatch(
              getCandidateRating({
                url: `${config.baseUrl}/Employers/get-candidate-rating_for_employer`,
                params: candidateRatingJson,
              })
            );
          });
          props?.getCandidateLocationStatusList(location.state.loctionId);
        })

      }







      sendMailModalClose();
      saveValidateInfo();
      setErrorMailPopupText("")
      setMailPopupText("")
    } else {
      setErrorMailPopupText("Please fill this field")
    }
  }

  // Certifications Comment Box onChange Event
  const handleChangeNotes = (target, candidateCertificationId) => {
    const { value } = target;
    if (value.length > 100) {
      return value;
    }
    const updateVal = JSON.parse(
      JSON.stringify(EmployerValidationGetCertificationList)
    );
    updateVal?.forEach((item) => {
      if (item.candidateCertificationId === candidateCertificationId) {
        if (value !== "") {
          item.notes = value;
        } else {
          item.notes = "";
        }
      }
    });
    dispatch(updateCertificationsData(updateVal));
  };

  // Certifications Uploads Check Box onChange event
  const handleChangeCheckBoxValidations = (
    target,
    candidateCertificationId,
  ) => {
    const { value, checked } = target;
    const updateVal = JSON.parse(
      JSON.stringify(EmployerValidationGetCertificationList)
    );
    updateVal?.forEach((item) => {
      if (item.candidateCertificationId === candidateCertificationId) {
        if (checked) {
          if (value === "validationyes") {
            item.validationState = 1;
          } else if (value === "validationno") {
            item.validationState = 0;
          }
        } else {
          if (value === "validationyes") {
            item.validationState = null;
          } else if (value === "validationno") {
            item.validationState = null;
          }
        }
        if (item?.expirationDate < formattedDate) {
          if (value === "validationyes") {
            item.validationState = null;
          }
          toast.warn("Uploaded certificate already expired")
        }
      } 
    });

    dispatch(updateCertificationsData(updateVal));
  };

  // Save Validation Certificates
  const saveValidateInfo = () => {
    const postData = [];
    const updateVal = JSON.parse(
      JSON.stringify(EmployerValidationGetCertificationList)
    );
    updateVal?.map((item) => {
      postData.push({
        candidateCertificationEmployerValidationId:
          item?.candidateCertificationEmployerValidationId,
        candidateCertificationId: item?.candidateCertificationId,
        validationState: item?.validationState,
        isActive: true,
        validatedBy: item?.validatedBy,
        validatedDate: new Date().toJSON(),
        notes: item?.notes,
      });
    });
    dispatch(
      saveCertificationEmployerValidation({
        baseUrl: config.baseUrl,
        employerUniqueId: login.employerUniqueId,
        candidateUniqueId: userData.candidateUniqueId,
        appUserUniqueId: login.appUserUniqueId,
        certificationsEmployersCandidatesValidationsFormDetails: [...postData],
      })
    ).then(() =>
      dispatch(
        getCertificationsList(
          `${config.baseUrl}`,
          login.employerUniqueId,
          userData.candidateUniqueId
        )
      )
    ).then(() => {


      if (userData && userData.candidateUniqueId) {
        const candidateRatingJson = {
          candidateUniqueId: userData.candidateUniqueId,
          jobUniqueId: "",
          locationId: 0,
          employerUniqueId: login.employerUniqueId,
        };
  
        dispatch(
          loadMasterData(`${config.baseUrl}`, login.employerUniqueId)
        ).then(() => {
          dispatch(
            getCandidateSearchViewDetail({
              url: `${config.baseUrl}/Candidates/get-candidate-infoV2`,
              candidateUniqueId: userData.candidateUniqueId,
              employerUniqueId: login.employerUniqueId,
            })
          ).then(() => {
            dispatch(
              getCandidateRating({
                url: `${config.baseUrl}/Employers/get-candidate-rating_for_employer`,
                params: candidateRatingJson,
              })
            );
          });
          props?.getCandidateLocationStatusList(location.state.loctionId);
        })
      }



    })


  };

  useEffect(() => {
    if (config.baseUrl) {
      try {
        dispatch(setLoading(true));
        dispatch(
          getCertificationsList(
            `${config.baseUrl}`,
            login.employerUniqueId,
            userData.candidateUniqueId
          )
        );
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(setError(error.message));
      }
    }
  }, [config]);

  // Employer Verification Comments History get from Selector
  const { EmployersVerificationCommentsHistory } = useSelector(
    candidateSearchViewSelector
  );
  // Employer Verification Comments History Pagination Part start
  const EmpcommentsHistoryData =
    EmployersVerificationCommentsHistory?.employersComments;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageNum, setCurrentPageNum] = useState(1);
  const [goTo, setGoTo] = useState("");
  const dataPerPage = useRef(5);
  const pageNumber = [];
  for (
    let i = 1;
    i < Math.ceil(EmpcommentsHistoryData?.length / dataPerPage.current) + 1;
    i++
  ) {
    pageNumber.push(i);
  }
  const indexOfLastItem = dataPerPage.current * currentPage;
  const indexOfCurrentItem = indexOfLastItem - dataPerPage.current;
  const EmpcommentsHistory = EmpcommentsHistoryData?.slice(
    indexOfCurrentItem,
    indexOfLastItem
  );

  // handleClick Employer Verification Comments Histroy function
  const handleClickEmpVerifyCommentsHistory = ({
    candidateUniqueId,
    employerUniqueId,
    candidateCertificationEmployerValidationId,
  }) => {
    dispatch(
      getEmployersVerificationCommentsHistory({
        baseUrl,
        candidateUniqueId,
        employerUniqueId,
        candidateCertificationEmployerValidationId,
      })
    );
    ToogleClick();
  };

  // Open Modal function for Employers Verification Comments History
  const ToogleClick = () => {
    setEmployersVerificationHistoryModalShow(
      !employersVerificationHistoryModalShow
    );
  };

  // Modal Close Btn Page Form and Value Reset function
  const ModalClosePage = () => {
    setCurrentPage(1);
    setCurrentPageNum(1);
    setGoTo("");
  };

  // Close Modal function For Employers Verification Comments History
  const closeEmployersCommentsModal = (e) => {
    e.preventDefault();
    setEmployersVerificationHistoryModalShow(
      !employersVerificationHistoryModalShow
    );
    ModalClosePage();
  };

  const downloadQACertification = async (item) => {
    const requestHeaders = {
      "Content-Type": "application/json",
      Authorization: login.accessToken ? `Bearer ${login.accessToken}` : "",
      "Website-Domain-Name":
        window.location.hostname === "localhost"
          ? localHostBaseURL
          : window.location.hostname ,
    };
    const params = {
      candidateUniqueId: userData?.candidateUniqueId ?? "",
      attachmentFileId: parseInt(item?.candidateCertificationAttachmentId) ?? 0,
    };
    try {
      dispatch(setLoadingFlagIncrement());
      const response = await fetch(
        `${config.baseUrl}/Employers/get-employer-certification-file-download`,
        {
          headers: { ...requestHeaders },
          method: "POST",
          body: JSON.stringify(params),
        }
      );
      const blob = await response.blob();
      let downnloadURL = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = downnloadURL;
      a.download = item?.attachedFileName;
      a.click();
    } catch (error) {
      toast.error(error.message)
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
  return (
    <div>
     {/* Upload Section While clicking "No" open a Modal box Send Mail */}
     {
                              mailPopup && (
                                  <Modal
                                    showHide={sendMailModalClose}
                                    label={"Compose Mail"}
                                    size={"lg"}
                                    buttonName={"Send"}
                                    saveFunction={sendMailToCandidateNoUploadcertificate}
                                  >
                                  <div className="d-flex flex-column gap-3">
                                    <span className="mx-2">
                                      Dear {" "} {props?.data?.firstName} {props?.data?.lastName},
                                    </span>
                                    <textarea className="form-control" style={{height: "100px"}} onChange={(e) => setMailPopupText(e.target.value)}/>
                                    <span className="text-danger">{errorMailPopupText}</span>
                                  </div>
                                  </Modal>
                                )
                          }
      {/* Modal Show for Employers Verification Comments History */}
      {employersVerificationHistoryModalShow && (
        <ModalWithPagination
          showHide={closeEmployersCommentsModal}
          label={"Employers Comments History"}
          size="lg"
          onlyClose={true}
          modalClass={"rounded-2"}
          pageNumber={pageNumber}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          currentPageNum={currentPageNum}
          setCurrentPageNum={setCurrentPageNum}
          setGoTo={setGoTo}
          goTo={goTo}
        >
          <div className="card-body">
            <div>
              <ul className="list-group ">
                {EmpcommentsHistory?.map((history) => {
                  return (
                    <li className="list-group-item d-flex justify-content-between">
                      {" "}
                      <span>{history.comment}</span>{" "}
                      <div className="d-flex flex-column">
                        <span style={{ fontSize: "12px" }}>
                          {history.commentByName}
                        </span>
                        <span style={{ fontSize: "12px" }}>
                          {history.commentDateToDisplay}
                        </span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </ModalWithPagination>
      )}
      <div>
        <div>
          <div className="PrintHeader">
            <h4 className="mb-0">Certifications, Licenses, Permits</h4>
          </div>
        </div>
        <div className="card-body">
          <div>
            <div className="row">
              <div className="col-lg-3"></div>
              <div className="col-lg-2 me-5 d-flex justify-content-center align-items-center">
              Expiration Date
              </div>
              <div className="col-lg-1 d-flex justify-content-center align-items-center">
                Uploads
              </div>
              <div className="col-lg-2 d-flex justify-content-center align-items-center">
                Validate Uploads
              </div>
              <div className="col d-flex justify-content-center align-items-center">
                Notes
              </div>
              <div className="col mt-1 btn d-flex justify-content-center align-items-center"></div>
            </div>
          </div>
          {EmployerValidationGetCertificationList?.map((item, i) => {
            return (
              <div className="card" key={i}>
                <div className="row p-3">
                  
                  <div className="col-lg-3 d-flex flex-column">
                    {/* Certificate Name */}
                    <span> {item.certificationName}</span>
                    <span>
                      <a
                      style={{cursor:"pointer"}}
                      onClick={() => downloadQACertification(item)}
                      
                        // href={`${item.downloadUrl}/${item.blobFileName}`}
                        rel="noreferrer"
                      >
                        <i>{item.attachedFileName}</i>
                        {item.attachedFileName ? (
                          <i
                            className="mdi mdi-arrange-bring-forward"
                            data-bs-toggle="tooltip"
                            title=""
                            data-bs-original-title="mdi-arrange-bring-forward"
                            aria-label="mdi-arrange-bring-forward"
                          ></i>
                        ) : (
                          ""
                        )}
                      </a>
                    </span>
                  </div>
                  <div className="col-lg-2 me-5 d-flex justify-content-center align-items-center">
                    {/* Expired Date To Display */}
                    {item.expirationDateToDisplay}
                  </div>
                  <div className="col-lg-1 d-flex justify-content-center align-items-center">
                    {/* Uploads */}
                    
                    {
                    item.certificationName === 'None' ? ( <div className="">N/A</div>) :
                    item.isUploaded === false ? (
                      <div className="text-danger">No</div>
                    ) : (
                      <div className="text-primary">Yes</div>
                    )}
                  </div>
                  <div className="col-lg-2 d-flex justify-content-center align-items-center">
                    {item.isUploaded === true ? (
                      <div className="d-flex gap-4">
                        <div>
                          {/* Yes Input */}
                          <input
                            className="checkboxView success"
                            type="checkbox"
                            // disabled={
                            //   (item?.expirationDate > formattedDate) === false 
                            // }
                            checked={parseInt(item.validationState) === 1}
                            value="validationyes"
                            onChange={(e) =>
                              handleChangeCheckBoxValidations(
                                e.target,
                                item?.candidateCertificationId,
                                item?.expirationDate
                              )
                            }
                          />
                          <span
                            style={{
                              color:
                                parseInt(item.validationState) === 1
                                  ? "green"
                                  : "black",
                            }}
                          >
                            {" "}
                            Yes
                          </span>
                        </div>
                        <div>
                          {/* No Input */}
                          <input
                            className="checkboxView failure"
                            type="checkbox"
                            checked={parseInt(item.validationState) === 0}
                            value={"validationno"}
                            style={{ accentColor: "red" }}
                            onClick={parseInt(item.validationState) === 0 ? "" : () => sendMailModalOpen(item?.candidateCertificationId)}
                            onChange={(e) =>
                              handleChangeCheckBoxValidations(
                                e.target,
                                item?.candidateCertificationId,
                              )
                            }
                          />
                          <span
                            style={{
                              color:
                                parseInt(item.validationState) === 0
                                  ? "Red"
                                  : "black",
                            }}
                          >
                            No
                          </span>
                        </div>
                         
                      </div>
                      
                    ) : (
                      <div></div>
                    )}
                  </div>
                  <div className="col d-flex justify-content-center align-items-center">
                    {/* Text area */}
                    <textarea
                      value={item?.notes}
                      onChange={(e) =>
                        handleChangeNotes(
                          e.target,
                          item?.candidateCertificationId
                        )
                      }
                    />
                  </div>
                  <div
                    className="col mt-1 btn d-flex justify-content-center align-items-center"
                    onClick={() =>
                      handleClickEmpVerifyCommentsHistory({
                        candidateUniqueId: userData.candidateUniqueId,
                        employerUniqueId: login.employerUniqueId,
                        candidateCertificationEmployerValidationId:
                          item.candidateCertificationEmployerValidationId,
                      })
                    }
                  >
                    <i class="fa fa-history fa-stack-1x"></i>
                  </div>
                </div>
              </div>
            );
          })}
          {/* Save Validate */}
          <div className="text-end">
            <button className="btn btn-success" onClick={saveValidateInfo}>
              Save Validate
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
